<template>
    <section class="our-story-wrapper pt-80px pb-80px">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="section-title text-center mb-30px">How It All Began</h1>
                </div>
            </div>
            <div class="row responsive-tablet-col-2 responsive-mobile-col-1">
                <div class="col-md-4">
                    <div class="our-story-box transition-3s">
                        <span class="q-icon">?</span>
                        <h1>Who we are?</h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias consectetur accusantium aliquam, vero molestiae quo nisi quasi</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="our-story-box transition-3s">
                        <span class="q-icon">?</span>
                        <h1>What we do?</h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias consectetur accusantium aliquam, vero molestiae quo nisi quasi</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="our-story-box transition-3s">
                        <span class="q-icon">?</span>
                        <h1>Why we do it?</h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias consectetur accusantium aliquam, vero molestiae quo nisi quasi</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
export default {
    name: 'OurStory',
    data() {
        return {

        }
    }
}
</script>